// extracted by mini-css-extract-plugin
module.exports = {"animatedBackground":"loadable-module--animated-background--3T5RL","loadable":"loadable-module--loadable--1NOwR","placeholder":"loadable-module--placeholder--2F5n0"};